import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { ContactGroupModel } from 'src/models/contactGroup.model';

const contactGroupAdapter: AdapterFunc<GQL.ContactGroupModel, ContactGroupModel> = (input) => ({
  id: input.id,
  name: input.name!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
});

export default contactGroupAdapter;
